import { useEffect, useState } from "react";

/**
 * ScrollProgress — thin sapphire-glow vertical bar on the right edge that
 * fills as the user scrolls the page. Desktop-only (hidden below lg).
 */
export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const top = window.scrollY || h.scrollTop || 0;
      const max = (h.scrollHeight - h.clientHeight) || 1;
      const p = Math.min(100, Math.max(0, (top / max) * 100));
      setProgress(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return (
    <div
      className="fixed right-3 top-1/2 -translate-y-1/2 h-[60vh] w-px z-50 hidden lg:block pointer-events-none"
      data-testid="scroll-progress"
    >
      <div className="absolute inset-0 bg-white/[0.06]" />
      <div
        className="absolute top-0 left-0 w-px transition-all duration-150 ease-out"
        style={{
          height: `${progress}%`,
          background: "linear-gradient(180deg, #93C5FD 0%, #60A5FA 50%, #2563EB 100%)",
          boxShadow: "0 0 10px rgba(96,165,250,0.85), 0 0 24px rgba(96,165,250,0.45)",
        }}
      />
    </div>
  );
}
